import { render, staticRenderFns } from "./StatsCard.vue?vue&type=template&id=71823a56"
import script from "./StatsCard.vue?vue&type=script&lang=js"
export * from "./StatsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports